const MinRating = ({ value }) => {
  return value ? (
    <span className="text-grayBlack text-[13px] font-medium">
      {value}
    </span>
  ) : (
    <p className="text-grayBlack text-xs font-medium">N/A</p>
  );
};

export default MinRating;
